import { render, staticRenderFns } from "./OverseasDetail.vue?vue&type=template&id=07ab314e&scoped=true"
import script from "./OverseasDetail.vue?vue&type=script&lang=js"
export * from "./OverseasDetail.vue?vue&type=script&lang=js"
import style0 from "./OverseasDetail.vue?vue&type=style&index=0&id=07ab314e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab314e",
  null
  
)

export default component.exports